var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{ref:"select",staticClass:"fake-select"},_vm._l((_vm.options),function(option){return _c('option',{key:_vm.getKey(option),domProps:{"value":_vm.getKey(option)}},[_vm._v(" "+_vm._s(option.title)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }